
export interface IFileUpload {
  document: File;
}

export interface IGapLoanPaidOffRequestInformation {
  payeeName: string | null,
  payeeAddress: string | null,
  payeeState: string | null,
  payeeZip: string | null
}

export interface IProductCheckRequestPayee {
  id?: string | number | undefined;
  lenderId: string;
  numericId: number;
  lenderName: string;
  payeeName: string;
  payeeAddress: string;
  isPayOffAddressForGAP: boolean;
  gapLoanPaidOffRequestInformation: IGapLoanPaidOffRequestInformation;
}

export interface IDealMoveImportResponse { 
  dealIds: string[];
  fileName: string;
  messages: string;
}

export enum ResponseType {
  Successfull = 'successfully',
}